<template>
  <div>
    <div v-if="!isLoading">
      <span v-if="showLevels">
        <b-row v-for="(partner, i) in partners" :key="i" class="mt-2">
          <b-col :title="`${$t('Click to copy')} (${partnerIds})`">
            <b-row class="hover-partner cursor-pointer" @click="copyToken(partner.token)">
              <b-col md="6">
                <small>{{ $t('Name') }} </small>
                <h6 class="text-primary">{{ partner.name }}</h6>
              </b-col>
              <b-col md="6">
                <small>{{ $t('Token') }} </small>
                <h6 class="text-primary">{{ partner.token }}</h6>
              </b-col>
              <b-col md="6">
                <small>{{ $t('Reward') }} </small>
                <h6 class="text-primary">{{ partner.reward.percentage * 100 }} %</h6>
              </b-col>
              <b-col md="6">
                <small>{{ $t('Nível') }} </small>
                <h6 class="text-primary">{{ partner.level }}</h6>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </span>
      <div v-if="!partners.length" class="row align-items-center text-center pb-4">
        <div class="mt-4 pt-1">
          <small>{{ $t('No partners registred') }}</small>
        </div>
      </div>
    </div>
    <sysa-skeleton v-else />
  </div>
</template>

<script>
export default {
  props: ['partnerLevel', 'showLevels'],
  data() {
    return {
      isLoading: false,
      partners: []
    };
  },
  created() {
    this.loadPartners(this.partnerIds);
  },
  methods: {
    loadPartners(partners = []) {
      this.partners = [];

      if (!partners?.length) return;

      this.isLoading = true;
      this.$api
        .get(`api/partner/all?partnerIds=${partners.join(',')}`)
        .then((res) => {
          this.isLoading = false;
          this.partners = res.data;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    copyToken(token) {
      navigator.clipboard
        .writeText(token)
        .then(() => {
          this.$customAlert({
            msg: this.$t('Token copied to clipboard!'),
            type: 'success'
          });
        })
        .catch((error) => {
          console.error('Failed to copy token:', error);
        });
    }
  },
  computed: {
    partnerIds() {
      if (!this.partnerLevel?.partners?.length || (this.partnerLevel?.partners || []).includes(null)) return [];
      return this.partnerLevel.partners;
    }
  }
};
</script>

<style>
.hover-partner {
  background-color: unset;
  border-radius: 10px;
  transition: background-color 0.6s ease-in-out;
}
.hover-partner:hover {
  background-color: #afafaf60;
  border-radius: 10px;
}
</style>
